import { FlexBox } from "components/Common/FlexBox"
import {
  IconWrapper,
  WeightChangedTitle,
  WeightChangedNotificationWrapper,
  WeightChangedText,
  WeightChangedTextStrong,
  ViewGoalLink,
  WeightChangedNotificationContent,
  CloseButton,
} from "./styled"
import PATHS from "router/paths"
import { useDisplayWeightChangedNotification } from "features/onboarding/hooks"
import { getDisplayCalories } from "utils"
import { useEffect } from "react"

const WeightChangedIcon = () => {
  return (
    <IconWrapper>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M10.0001 7.50019V10.8335M10.0001 14.1669H10.0085M8.84622 3.24329L1.99215 15.0821C1.61198 15.7388 1.42189 16.0671 1.44999 16.3366C1.47449 16.5716 1.59763 16.7852 1.78876 16.9242C2.0079 17.0835 2.38728 17.0835 3.14605 17.0835H16.8542C17.613 17.0835 17.9923 17.0835 18.2115 16.9242C18.4026 16.7852 18.5258 16.5716 18.5503 16.3366C18.5783 16.0671 18.3883 15.7388 18.0081 15.0821L11.154 3.24329C10.7752 2.58899 10.5858 2.26184 10.3387 2.15196C10.1232 2.05612 9.87709 2.05612 9.66154 2.15196C9.41443 2.26184 9.22503 2.58899 8.84622 3.24329Z"
          stroke="#0DA3BA"
          strokeWidth="1.66667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconWrapper>
  )
}

const CloseIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <g clipPath="url(#clip0_12106_59054)">
        <path
          d="M16.7176 7.29209C16.341 6.91551 15.7327 6.91551 15.3561 7.29209L12 10.6385L8.64388 7.28243C8.26731 6.90586 7.659 6.90586 7.28243 7.28243C6.90586 7.659 6.90586 8.26731 7.28243 8.64388L10.6385 12L7.28243 15.3561C6.90586 15.7327 6.90586 16.341 7.28243 16.7176C7.659 17.0941 8.26731 17.0941 8.64388 16.7176L12 13.3615L15.3561 16.7176C15.7327 17.0941 16.341 17.0941 16.7176 16.7176C17.0941 16.341 17.0941 15.7327 16.7176 15.3561L13.3615 12L16.7176 8.64388C17.0845 8.27697 17.0845 7.659 16.7176 7.29209Z"
          fill="#69757D"
        />
      </g>
      <defs>
        <clipPath id="clip0_12106_59054">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

const WeightChangedNotification = () => {
  const {
    caloriesPerDay,
    newCaloriesPerDay,
    handleTurnOffWeightChangedNotification,
  } = useDisplayWeightChangedNotification()

  return (
    <WeightChangedNotificationWrapper>
      <WeightChangedNotificationContent>
        <FlexBox $gap={8} $alignItems="center">
          <WeightChangedIcon />
          <WeightChangedTitle>
            Looks like your weight has changed!
          </WeightChangedTitle>
        </FlexBox>

        <div>
          <WeightChangedText>
            We've recalculated your daily intake from{" "}
            <WeightChangedTextStrong>
              {getDisplayCalories(caloriesPerDay)}
            </WeightChangedTextStrong>{" "}
            cal to{" "}
            <WeightChangedTextStrong>
              {getDisplayCalories(newCaloriesPerDay)}
            </WeightChangedTextStrong>{" "}
            {""}
            cal. Would you like to update your goal?
          </WeightChangedText>

          <ViewGoalLink to={PATHS.app.yourGoal.root}>View goal</ViewGoalLink>
        </div>

        <CloseButton onClick={handleTurnOffWeightChangedNotification}>
          <CloseIcon />
        </CloseButton>
      </WeightChangedNotificationContent>
    </WeightChangedNotificationWrapper>
  )
}

export default WeightChangedNotification
